"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const react_native_1 = require("react-native");
const screenConstants_1 = require("../../../constants/screenConstants");
const imageInput_1 = __importDefault(require("../../../components/documentUpload/imageInput/imageInput"));
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const choices_1 = require("../../../utils/choices");
const states_1 = require("../../../utils/states");
const store_1 = require("../../../store");
const onboardingUtils_1 = require("../onboardingUtils");
const utils_1 = require("../../../utils/utils");
const useAppNavigation_1 = __importDefault(require("../../../hooks/useAppNavigation"));
const input_1 = __importStar(require("../../../components/input/input"));
const navContainer_1 = __importDefault(require("../../../components/navContainer/navContainer"));
const analytics_1 = require("../../../utils/analytics/analytics");
const text_1 = __importStar(require("../../../components/text/text"));
const colors_1 = __importDefault(require("../../../styles/colors"));
const OnboardingPersonalInformation = () => {
    const { firstName, lastName } = (0, store_1.useAppSelector)((state) => ({
        firstName: state.home.user_data ? state.home.user_data.personal_information.first_name : state.auth.first_name,
        lastName: state.home.user_data ? state.home.user_data.personal_information.last_name : state.auth.last_name,
    }));
    const navigation = (0, useAppNavigation_1.default)();
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [errors, setErrors] = (0, react_1.useState)();
    const [firstNameLocal, setFirstName] = (0, react_1.useState)(firstName);
    const [lastNameLocal, setLastName] = (0, react_1.useState)(lastName);
    const [genderLocal, setGender] = (0, react_1.useState)('');
    const [dateOfBirth, setDateOfBirth] = (0, react_1.useState)('');
    const [profilePhoto, setProfilePhoto] = (0, react_1.useState)({});
    const [profilePhotoName, setProfilePhotoName] = (0, react_1.useState)('');
    const [bvnState, setBvn] = (0, react_1.useState)('');
    const [typeId, setTypeId] = (0, react_1.useState)('');
    const [idNumber, setIdNumber] = (0, react_1.useState)('');
    const [idDocument, setIdDocument] = (0, react_1.useState)({});
    const [idDocumentName, setIdDocumentName] = (0, react_1.useState)('');
    const [addressState, setAddress] = (0, react_1.useState)('');
    const [stateState, setState] = (0, react_1.useState)('');
    const [lgaState, setLga] = (0, react_1.useState)('');
    const [dateMovedIntoAddress, setDateMoved] = (0, react_1.useState)('');
    // SUBMIT FORM DATA
    const submitForm = async () => {
        setIsLoading(true);
        let payload = {
            // information
            first_name: firstNameLocal.toString(),
            last_name: lastNameLocal.toString(),
            gender: genderLocal,
            date_of_birth: (0, utils_1.databaseDateFormat)(dateOfBirth.toString()),
            // indentification details
            bvn: bvnState.toString(),
            nigeria_identification_type: typeId,
            identification_number: idNumber.toString(),
            // residential details
            address: addressState.toString(),
            state: stateState,
            lga: lgaState,
            date_moved_address: (0, utils_1.databaseDateFormat)(dateMovedIntoAddress.toString()),
        };
        const formDataPayload = new FormData();
        Object.entries(payload).forEach((entry) => {
            formDataPayload.append(entry[0], entry[1]);
        });
        if (typeof profilePhoto === 'string') {
            const profilePhotoBlob = await fetch(profilePhoto).then((r) => r.blob());
            payload = { ...payload, profile_photo: profilePhotoBlob };
            // @ts-ignore
            formDataPayload.append('profile_photo', profilePhotoBlob, profilePhotoName);
        }
        if (typeof idDocument === 'string') {
            const idDocumentBlob = await fetch(idDocument).then((r) => r.blob());
            payload = { ...payload, identity_document: idDocumentBlob };
            // @ts-ignore
            formDataPayload.append('identity_document', idDocumentBlob, idDocumentName);
        }
        const result = await dispatch((0, onboardingUtils_1.submitOnboardingProfile)(formDataPayload));
        logEventWithExtraProperties('api_call', {
            name: 'submit_onboarding_borrower_information',
            status: 'submitted',
            location: 'screen_OnboardingPersonalInformation',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'submit_onboarding_borrower_information',
                status: 'success',
                location: 'screen_OnboardingPersonalInformation',
            });
            setErrors(undefined);
            setIsLoading(false);
            navigation.reset({ index: 0, routes: [{ name: screenConstants_1.HOME_SCREEN }] });
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'submit_onboarding_borrower_information',
                status: 'fail',
                location: 'screen_OnboardingPersonalInformation',
            });
            setErrors(result.payload);
            setIsLoading(false);
        }
    };
    const validFormats = 'Upload Image (PNG, JPEG, PDF)';
    return (react_1.default.createElement(navContainer_1.default, { titleText: "Personal Information", subTitleText: "Kindly provide the following information.", errors: errors, isLoading: isLoading, footer: react_1.default.createElement(primaryButton_1.default, { title: "Save", onPress: submitForm, disabled: false, eventName: "personalInformation_save" }) },
        react_1.default.createElement(imageInput_1.default, { typeAvatar: true, toUploadTitle: "Upload a Photo", image: profilePhoto, setImage: setProfilePhoto, setImageName: setProfilePhotoName, error: (0, utils_1.getError)('profile_photo', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "First name", placeholder: "First name", setValue: setFirstName, value: firstNameLocal, error: (0, utils_1.getError)('first_name', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "Last name", placeholder: "Last name", setValue: setLastName, value: lastNameLocal, error: (0, utils_1.getError)('last_name', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Gender", choices: choices_1.genderChoices, setValue: setGender, value: genderLocal || '', error: (0, utils_1.getError)('gender', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_DATE, label: "Date of birth", setValue: setDateOfBirth, value: dateOfBirth, error: (0, utils_1.getError)('date_of_birth', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_NUMBER, isBVN: true, label: "BVN", placeholder: "BVN", setValue: setBvn, value: bvnState, error: (0, utils_1.getError)('bvn', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Type of ID document", choices: choices_1.typeDocumentChoices, setValue: setTypeId, value: typeId, error: (0, utils_1.getError)('nigeria_identification_type', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_NUMBER, label: "ID number", placeholder: "ID number", setValue: setIdNumber, value: idNumber, error: (0, utils_1.getError)('identification_number', errors) }),
        react_1.default.createElement(react_native_1.View, { style: { top: 8 } },
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE_SIZE_12, color: colors_1.default.COLOR_PRIMARY }, validFormats)),
        react_1.default.createElement(imageInput_1.default, { toUploadTitle: "Upload ID Document", image: idDocument, setImage: setIdDocument, setImageName: setIdDocumentName, error: (0, utils_1.getError)('identity_document', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "Address", placeholder: "Address", setValue: setAddress, error: (0, utils_1.getError)('address', errors), value: addressState }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "State", choices: (0, states_1.getStates)(), setValue: setState, value: stateState, error: (0, utils_1.getError)('state', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Local government area", choices: (0, states_1.getLga)(stateState.toString()), setValue: setLga, value: lgaState, error: (0, utils_1.getError)('lga', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_DATE, label: "When did you move to this address?", setValue: setDateMoved, value: dateMovedIntoAddress, error: (0, utils_1.getError)('date_moved_address', errors) })));
};
exports.default = OnboardingPersonalInformation;
